import { createFileRoute } from "@tanstack/react-router";
import AdminSystemHealth from "@/pages/AdminSystemHealth";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/system-health/")({
  component: () => (
    <RoleGate allow={['staff','viewer']} area="System Health"><AdminSystemHealth /></RoleGate>
  ),
});
